import React from 'react'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'

import {FacilitiesGridLoader} from '../Facilities'
import {MAXIMUM_POPULAR_FACILITIES} from './constants'

export const PopularFacilitiesLoading = () => {
  const {isMobile} = useDeviceLayout()
  if (isMobile)
    return <FacilitiesGridLoader items={MAXIMUM_POPULAR_FACILITIES} />
  return <FacilitiesGridLoader variant="secondary" items={9} rowGap="s400" />
}
